"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.futuresTickersReducer = exports["default"] = void 0;
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _unionBy = _interopRequireDefault(require("lodash/unionBy"));
var _futuresTickersActions = require("../actions/futuresTickersActions");
var _config = _interopRequireDefault(require("../../../config"));
var _config$TickerData;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  tickers: [],
  interval: ((_config$TickerData = _config["default"].TickerData) === null || _config$TickerData === void 0 ? void 0 : _config$TickerData.defaultInterval) || 300,
  // Default to 300 if not specified
  fetching: true
};
var futuresTickersReducer = exports.futuresTickersReducer = function futuresTickersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _futuresTickersActions.RECEIVE_FUTURES_TICKERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        tickers: (0, _sortBy["default"])(payload, '0')
      });
    case _futuresTickersActions.ADD_FUTURES_TICKERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        // Same workaround as in standard tickers for AS-20936
        // 1. combine payload and state by the first entry — EndDateTime
        // 2. sort in the ASC order by the same field
        tickers: (0, _sortBy["default"])((0, _unionBy["default"])(payload, state.tickers, '0'), '0')
      });
    case _futuresTickersActions.REQUEST_FUTURES_TICKERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true
      });
    case _futuresTickersActions.SET_FUTURES_TICKERS_INTERVAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        interval: payload
      });
    default:
      return state;
  }
};
var _default = exports["default"] = futuresTickersReducer;